import { SearchDocument } from '@/shared/api/global-search'
import { useTranslation } from 'react-i18next'
import { DocumentContentItem, DocumentItem } from './DocumentItem'
import { FolderItem } from './FolderItem'
import { ProjectItem } from './ProjectItem'
import { TaskItem } from './TaskItem'

interface RecentSearchesProps {
    searches?: SearchDocument[]
    isHidden?: boolean
    onClose?: () => void
}

export function RecentSearches({ searches = [], isHidden = false, onClose }: RecentSearchesProps) {
    const { t } = useTranslation()
    if (isHidden) return null
    const hasSearches = searches && searches.length > 0
    return (
        <div>
            <h3 className="text-sm font-semibold mb-3 leading-5">{t('globalSearch.recentSearches')}</h3>
            {!hasSearches ? (
                <div className="flex items-center justify-center py-12">
                    <p className="text-sm text-muted-foreground">{t('globalSearch.noSearchHistory')}</p>
                </div>
            ) : (
                <div>
                    {searches.map(item => {
                        const highlights = item['@search.highlights']

                        switch (item.entityType) {
                            case 'PROJECT':
                                return (
                                    <ProjectItem
                                        key={item.id}
                                        title={item.title}
                                        code={item.code}
                                        description={item.description}
                                        highlights={highlights}
                                        id={item.id}
                                        onClick={onClose}
                                    />
                                )
                            case 'FOLDER':
                                return (
                                    <FolderItem
                                        key={item.id}
                                        title={item.title}
                                        path={item.path}
                                        highlights={highlights}
                                        id={item.id}
                                        projectId={item.projectId}
                                        onClick={onClose}
                                    />
                                )
                            case 'TASK':
                                return (
                                    <TaskItem
                                        key={item.id}
                                        title={item.title}
                                        code={item?.code}
                                        description={item?.description}
                                        path={item?.path}
                                        highlights={highlights}
                                        onClick={onClose}
                                        id={item.id}
                                        projectId={item.projectId}
                                    />
                                )
                            case 'DOCUMENT':
                                return (
                                    <DocumentItem
                                        key={item.id}
                                        title={item.title}
                                        code={item.code}
                                        description={item.description}
                                        highlights={highlights}
                                        id={item.id}
                                        projectId={item.projectId}
                                        onClick={onClose}
                                    />
                                )
                            case 'DOCUMENT_CONTENT':
                                return (
                                    <DocumentContentItem
                                        key={item.id}
                                        title={item.title}
                                        code={item.code}
                                        content={item.content}
                                        highlights={highlights}
                                        id={item.id}
                                        projectId={item.projectId}
                                        documentId={item.documentId}
                                        onClick={onClose}
                                    />
                                )
                            default:
                                return null
                        }
                    })}
                </div>
            )}
        </div>
    )
}
